/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { productInformationSearchQueryStyles } from "@stoneage/App/Widgets/ProductInformation/ProductInformationSearchQuery";
import { color } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

productInformationSearchQueryStyles.wrapper = {
    css: css`
        padding: 12px;
        background-color: ${color("common.ui4")};
    `,
};

productInformationSearchQueryStyles.titleText = {
    size: 15,
    color: "text.main",
    weight: "bold",
    css: css`
        margin-bottom: 8px;
        letter-spacing: 0;
    `,
};

productInformationSearchQueryStyles.searchTextField = {
    iconProps: { src: "IconSearch", size: 35 },
    cssOverrides: {
        formField: css`
            width: 100%;
            font-style: italic;
        `,
        formInputWrapper: css`
            margin-top: 8px;
            && button {
                right: -4px;
            }
            && button > span {
                color: ${color("primary.main")};
                padding: 0;
            }
        `,
        inputSelect: css`
            font-style: italic;
        `,
    },
};

productInformationSearchQueryStyles.filterTag = {
    mergeCss: true,
    css: css`
        margin: 8px 0 0 0;
    `,
};
